import { render, staticRenderFns } from "./sportbook-matche.vue?vue&type=template&id=ca2c11ec&scoped=true&"
import script from "./sportbook-matche.vue?vue&type=script&lang=js&"
export * from "./sportbook-matche.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-matche.vue?vue&type=style&index=0&id=ca2c11ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2c11ec",
  null
  
)

export default component.exports